// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './condition-status.properties';

const CONDITION_STATUS_VALUES = [
  'VALID',
  'MISSING_ATTRIBUTE',
  'ATTRIBUTE_WRONG_TYPE',
  'ATTRIBUTE_UNREACHABLE',
  'INCOMPATIBLE_VALUES',
  'FILTER_GEOMETRY_EXCEEDS_CONFIGURED_LIMITS',
] as const;

/** @see net/disy/cadenza/workbook/model/ConditionStatus.java */
export type ConditionStatus = (typeof CONDITION_STATUS_VALUES)[number];

export const ConditionStatus = {
  values: CONDITION_STATUS_VALUES as readonly ConditionStatus[],
  i18n: (value: ConditionStatus) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>
